import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonServiceCrumbs } from 'system/constants/common-service-crumbs';
import OperatorDetail from 'system/components/operators/detail';
import { useParams, useNavigate, generatePath } from 'react-router';

const OperatorDetailPageServiceEdit = (): React.ReactElement => {
  const params = useParams();
  const navigate = useNavigate();

  const onCancel = useCallback(() => {
    navigate(generatePath('/sistema/servizi/modifica/:id', params));
  }, [navigate]);

  return (
    <Fragment>
      <Breadcrumbs
        items={[
          ...CommonServiceCrumbs,
          { name: 'Modifica Servizio', path: '/sistema/servizi/modifica/:id' },
          { name: 'Dettaglio Operatore' },
        ]}
      />
      <OperatorDetail onCancel={onCancel} id={params.idOperatore} />
    </Fragment>
  );
};

OperatorDetailPageServiceEdit.displayName = 'Operator Edit page component from services edit';

export default OperatorDetailPageServiceEdit;
